import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { Input, Label } from '@naf/input';
import * as S from './RequestOfferInput.styles';

interface RequestOfferInputProps {
  licensePlateNumber?: string;
  setLicensePlateNumber?: (number: string) => void;
  handleRequestClick?: () => void;
  error?: string;
  pageType?: string;
}

export const RequestOfferInput = ({
  licensePlateNumber,
  setLicensePlateNumber,
  error,
  handleRequestClick,
  pageType,
}: RequestOfferInputProps) => (
  <S.Container>
    <S.InputContainer>
      <Text variant={TextVariant.ArticleTextSubHeader}>Be om et uforpliktende tilbud på {pageType} på</Text>
      <Label>Registreringsnummer</Label>
      <Input
        name="plateNumber"
        label="Registreringsnummer"
        placeholder="Søk etter kjøretøy"
        value={licensePlateNumber}
        onChange={(number: string) => setLicensePlateNumber(number)}
        error={!!error}
      />
      {error && <S.ErrorMessage variant={TextVariant.Small}>{error}</S.ErrorMessage>}
    </S.InputContainer>
    <S.StyledButton onClick={handleRequestClick}>Send forespørsel</S.StyledButton>
  </S.Container>
);

export default RequestOfferInput;
